module.exports = __webpack_public_path__ + "static/media/website-08.1966b17f.png";